// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.related__list .swiper-slide {
  background-color: transparent;
  height: auto !important;
}
.related__list .swiper-slide .ant-card {
  height: 100%;
}

.block-related__swiper {
  overflow: visible;
}
.block-related__navigation {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  margin-top: 24px;
  position: relative;
  --swiper-navigation-color: var(--related-navigation-color);
}
.block-related__navigation .swiper-button-prev,
.block-related__navigation .swiper-button-next {
  position: static;
  margin-top: 0;
  background-color: var(--primary-color);
  border-radius: 50%;
  padding: 0rem;
}
.block-related__navigation .swiper-button-prev svg,
.block-related__navigation .swiper-button-next svg {
  width: 50%;
  height: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Related/Related.scss"],"names":[],"mappings":"AAEQ;EACI,6BAAA;EACA,uBAAA;AADZ;AAEY;EACI,YAAA;AAAhB;;AAOI;EACI,iBAAA;AAJR;AAOI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EAEA,0DAAA;AANR;AAQQ;;EAEI,gBAAA;EACA,aAAA;EAEA,sCAAA;EACA,kBAAA;EACA,aAAA;AAPZ;AASY;;EACI,UAAA;EACA,WAAA;AANhB","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
